import { mdiSignal, mdiSignalOff } from "@mdi/js";
import { BaseColor } from "@soft-db/ui";
import { StationStatusStateExtended } from "../../../stores";

export type StateBadge = {
	state: StationStatusStateExtended;
	icon: string;
	text: string;
	color: BaseColor;
};

export function useStateBadge(
	state: MaybeRefOrGetter<StationStatusStateExtended | null | undefined>
): ComputedRef<StateBadge | null> {
	const { t } = useI18n();

	const onlineBadge = computed<StateBadge>(() => ({
		state: "online",
		color: "success",
		icon: mdiSignal,
		text: t("live-status.online"),
	}));

	const idleBadge = computed<StateBadge>(() => ({
		state: "waiting",
		color: "warning",
		icon: mdiSignal,
		text: t("live-status.idle"),
	}));

	const offlineBadge = computed<StateBadge>(() => ({
		state: "offline",
		color: "error",
		icon: mdiSignalOff,
		text: t("live-status.offline"),
	}));

	return computed(() => {
		switch (toValue(state)) {
			case "offline":
			case "recently-offline":
				return offlineBadge.value;

			case "online":
				return onlineBadge.value;

			case "waiting":
				return idleBadge.value;

			default:
				return null;
		}
	});
}
